import React from "react";
import {TextField, useRecordContext} from 'react-admin';
const CustomUserNameField = ({...rest}) => {
    const record = useRecordContext();
    return (
        <React.Fragment>
            <TextField source="first_name" record={record} {...rest}/>
            &nbsp;
            <TextField source="last_name" record={record} {...rest}/>
        </React.Fragment>
    );
};

export default CustomUserNameField;
